import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import Releases from '@/views/releases/index.vue'

const releasesRoutes: RouteRecordRaw[] = [
  {
    path: '/releases',
    name: 'Releases',
    component: Releases,
    meta: {
      layout: DefaultLayout,
      middleware: ['auth'],
      title: 'بروزرسانی فنی',
    },
  },
]

export default releasesRoutes
